// @flow

import create, { type Settings } from "./create";

let client;

export const configure = (settings: Settings) => {
    client = create(settings);
};

client = create();

export default () => client;
export { default as useApi } from "./hook";
